import * as Yup from 'yup';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default () => {
  const today = momentLocalTimezone().startOf('day');
  const endOfMonth = momentLocalTimezone().endOf('month');

  return Yup.object().shape({
    contractId: Yup.number().required('SCHEMA_ERRORS.CONTRACT_REQUIRED'),
    transactionId: Yup.number().required('SCHEMA_ERRORS.INVOICE_REQUIRED'),
    dueDate: Yup.date()
      .required('SCHEMA_ERRORS.DATE_REQUIRED')
      .typeError('SCHEMA_ERRORS.DATE_MUST_BE_VALID')
      .min(today, 'SCHEMA_ERRORS.DATE_MUST_BE_VALID')
      .max(endOfMonth, 'SCHEMA_ERRORS.DATE_MUST_BE_VALID')
  });
};
